export function initChmln() {
  /* Chameleon - better user onboarding */
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  !(function (t, n, o) {
    var a = 'chmln',
      e = 'adminPreview',
      c = 'setup identify alias track clear set show on off custom help _data'.split(' ');

    if ((n[a] || (n[a] = {}), n[a][e] && (n[a][e] = !1), !n[a].root)) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      ((n[a].accountToken = o), (n[a].location = n.location.href.toString()), (n[a].now = new Date()));
      for (var s = 0; s < c.length; s++)
        // @ts-expect-error -- This code was written prior to enforcing lint rules
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        !(function () {
          var t = (n[a][c[s] + '_a'] = []);
          n[a][c[s]] = function () {
            t.push(arguments);
          };
        })();
      var i = t.createElement('script');
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      ((i.src = 'https://fast.trychameleon.com/messo/' + o + '/messo.min.js'), (i.async = !0), t.head.appendChild(i));
    }
  })(document, window, 'SIMVvFC0cW5aRmXMWnBWuSrsLp6oY3utpm8ZD5ciik5ByF-1H74NM-Bgha6VrqZM0nduVB');
}
